import { Button, Icon, Theme, useTheme } from 'bold-ui'
import { useSession } from 'components/auth/useSession'
import { BackToOriginUrlParams } from 'components/back-to-origin-button/backToOriginButton-model'
import { CIDADAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { css } from 'emotion'
import { useUrlQueryParams } from 'hooks/useUrlQueryParams'
import { useHistory, useLocation } from 'react-router'
import Permissions from 'types/Permissions.generated'
import { JUSTIFICATIVA_VISUALIZAR_PRONTUARIO_BY_PRONTUARIO_FAMILIAR } from 'view/atendimentos/detail/prontuario-familiar/model-prontuarioFamiliar'
import { grupoCboVisualizarProntuario } from 'view/cidadao/authorization/acessos'
import { getBotaoRetornarCallbackParams } from 'view/cidadao/utils-cidadao'
import { useSubmitJustificativaVisualizarProntuario } from 'view/prontuario/justificativa/useSubmitJustificativaVisualizarProntuario'

interface VisualizacaoCidadaoButtonProps {
  cidadaoId: ID
  prontuarioId?: ID
}

export const VisualizarCidadaoButton = (props: VisualizacaoCidadaoButtonProps) => {
  const { cidadaoId, prontuarioId } = props
  const location = useLocation()
  const history = useHistory()

  const theme = useTheme()
  const styles = createStyles(theme)

  const { hasAuthorization, hasCboAuth } = useSession()

  const hasPermissionVisualizarProntuario =
    hasAuthorization(Permissions.visualizarProntuario) && hasCboAuth(grupoCboVisualizarProntuario)

  const { backToOriginUrl } = useUrlQueryParams<BackToOriginUrlParams>()

  const { submitJustificativa } = useSubmitJustificativaVisualizarProntuario(cidadaoId)

  const handleVisualizarClick = async () => {
    const searchString = getBotaoRetornarCallbackParams(location.pathname, location.search)

    const isVindoDoAtendimento =
      backToOriginUrl?.includes('/lista-atendimento/') || location.pathname.includes('/lista-atendimento/')

    if (hasPermissionVisualizarProntuario && isVindoDoAtendimento && prontuarioId) {
      const justificativaId = await submitJustificativa(prontuarioId, {
        justificativa: JUSTIFICATIVA_VISUALIZAR_PRONTUARIO_BY_PRONTUARIO_FAMILIAR,
      })
      if (justificativaId) {
        history.push(`${CIDADAO_PATH}/${cidadaoId}/folha-rosto${searchString}`)
      }
    } else {
      history.push(`${CIDADAO_PATH}/${cidadaoId}/informacoes${searchString}`)
    }
  }

  return (
    <Button skin='ghost' kind='primary' onClick={handleVisualizarClick} style={styles.button}>
      <Icon icon='zoomOutline' />
    </Button>
  )
}

const createStyles = (theme: Theme) => {
  return {
    button: css`
      color: ${theme.pallete.gray.c20};
      padding: 0.5rem;
      margin-left: 3rem;
    `,
  }
}
